import { API } from '../../../api';
export default function CarouselListItem({ key, slide, onHover, onEdit, onDelete }) {

  const getImageUrl = (baseUrl=API.API_LINK + "/") => {
    if (slide.typesource === "web") return slide.imgname;
    if (!slide.imgname || !slide.extension) return null;
    return `${baseUrl}file/pictures/carrousel/source/${slide.imgname}.${slide.extension}`;
  };

  return (
    <li className="carrousel-list-item" onMouseEnter={() => onHover?.(slide)}>
    	<div className="item-info">
        	<div className="item-thumb">
          		{getImageUrl() ? (
            		<img src={getImageUrl()} alt={slide.imgtitre || "Image"} onError={e => e.target.style.display = "none"} />
          		) : (
            		<div className="empty-thumb fdgdfgdgdg"><span>📷</span></div>
          		)}
        	</div>

        	<div className="item-details">
          		<h4>{slide.imgtitre || "Sans titre"}</h4>
          		<p className="item-event">{slide.evenement}</p>
          		<p className="item-visibility">{slide.isvisible ? "✓ Visible" : "✗ Masqué"}</p>
        	</div>
      	</div>

      	<div className="item-actions">
        	<button className="btn-icon btn-edit" onClick={() => onEdit(slide)} title="Modifier">✏️</button>
        	<button className="btn-icon btn-delete" onClick={() => onDelete(slide)} title="Supprimer">🗑️</button>
      	</div>
    </li>
  );
}